@if (isAuth$ | async) {
  <div style="height: 100%">
    <mat-menu #userTopMenu="matMenu"
      [overlapTrigger]="false" xPosition="before"
      class="user-top-menu">
      <a mat-menu-item routerLink="/channels">
        <mat-icon>rss_feed</mat-icon>
        <ng-container i18n="Top menu|button @@topMenu.myChannels">Мои Каналы Telegram</ng-container>
      </a>
      <a mat-menu-item routerLink="/posts-calendar">
        <mat-icon>date_range</mat-icon>
        <ng-container i18n="Top menu|button @@topMenu.publicationsCalendar">Календарь публикаций</ng-container>
      </a>
      <a mat-menu-item routerLink="/bots">
        <mat-icon>android</mat-icon>
        <ng-container i18n="Top menu|button @@topMenu.myBots">Мои Боты</ng-container>
      </a>
      <a mat-menu-item routerLink="/settings">
        <mat-icon>settings_applications</mat-icon>
        <ng-container i18n="Top menu|button @@topMenu.settings">Настройки</ng-container>
      </a>
      <a mat-menu-item (click)="changeLanguageDialog()">
        <mat-icon>language</mat-icon>
        <ng-container i18n="Top menu|button @@topMenu.language">Язык</ng-container>
      </a>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="login.signOut()">
        <mat-icon>exit_to_app</mat-icon>
        <ng-container i18n="Top menu|button @@topMenu.logOut">Выйти</ng-container>
      </button>
      @if (user$ | async; as user) {
        @if (getOldToken()) {
          <button mat-menu-item (click)="logOutUser(user.id)">
            <mat-icon>exit_to_app</mat-icon>
            Выйти с пользователя
          </button>
        }
        @if (user.siteAdmin) {
          <a mat-menu-item routerLink="/admins">
            <mat-icon>recent_actors</mat-icon>
          Админка</a>
        }
      }
    </mat-menu>
    <button class="user-top-menu-trigger" mat-button #trigger="matMenuTrigger"
      [matMenuTriggerFor]="userTopMenu"
      style="height: 100%;"
      [class.menuOpen]="trigger.menuOpen">
      @if (user$ | async; as user) {
        @if (showAvatar) {
          <img class="circle-img" [src]="user?.photoUrl" width="40" height="40" alt="">
        }
        <span fxHide.xs="" style="display: inline-block; max-width: 150px"
        class="short-string">{{user?.firstName}} {{user?.lastName}}</span>
        <!--<mat-icon fxHide.xs="" class="material-icons">arrow_drop_down</mat-icon>-->
      }
    </button>
  </div>
}

